export function fromPythonTS(pythonTS) {
    return pythonTS * 1000
}

export function toPythonTS(jsTS) {
    return Math.floor(jsTS / 1000)
}



// WEBPACK FOOTER //
// ./utils/time.js